export default {
  label: '会计',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '负责日常账务处理、凭证审核、账簿登记等',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '负责日常账务处理，包括原始凭证的审核、记账凭证的编制、账簿登记等',
          id: '0-2-1',
        },
        {
          label: '编制财务报表（如资产负债表、利润表等），确保数据的准确性和完整性',
          id: '0-2-2',
        },
        {
          label: '进行月末结账、年度决算等工作，并对账目进行核对',
          id: '0-2-3',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '学历要求：大专及以上学历，财会相关专业优先',
          id: '0-3-1',
        },
        {
          label: '技能要求：熟练使用ERP系统或其他财务软件，具备良好的数据分析能力和沟通能力',
          id: '0-3-2',
        },
        {
          label: '职业素养：具有较强的责任心、保密意识和团队合作精神',
          id: '0-3-3',
        }
      ],
    },
    {
      label: '薪资情况',
      id: '0-4',
      children: [
        {
          label: '4000-6000元',
          id: '0-4-1',
        },
      ],
    }
  ],
};